var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.209,
    d: "M9.107 1.7c6.895 4.15 12.572 14.11 2.434 16.6 2.193-2.49 4.267-6.225-.812-9.96.65 1.992-.052 3.735-.728 4.565-.415-2.075-2.092-2.49-2.903-2.905.414 1.66-.415 2.49-.83 3.32-1.203 2.408.541 4.15 1.217 4.98-4.46-1.66-6.06-6.114-2.839-9.96C7.08 5.435 8.296 4.605 9.107 1.7"
  })));
};
export default SvgFire;